import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface BulkDeleteTagsRequest {
	query?: string | null;
	excludeTagIds?: string[];
}

interface UseBulkDeleteTagsMutationOptions {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	impersonationContext?: Api.IImpersonationContext;
}

export function useBulkDeleteTagsMutation({
	onSuccess,
	onError,
	impersonationContext,
}: UseBulkDeleteTagsMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async (request: BulkDeleteTagsRequest) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'tag/bulkDelete',
				}),
				'POST',
				request
			);
		},
		onSuccess,
		onError,
	});
}
